// ============================================================
// GOD-TIER LUXURY LIGHTBOX – Rolex/Apple Level (2025)
// Click → 80% → Click → 100% + Hover + Mouse Wheel Zoom
// ============================================================
(() => {
  'use strict';

  class GodTierLuxuryLightbox {
    constructor() {
      this.root = document.getElementById('CustomProductMediaLightbox');
      if (!this.root) return;

      this.items = [];
      this.current = 0;
      this.scale = 0.8;
      this.translate = { x: 0, y: 0 };
      this.isZoomed = false;

      this.container = this.root.querySelector('.custom-lightbox__image-container');
      this.counter = document.getElementById('media-index-display');
      this.thumbsInner = this.root.querySelector('.pswp__thumbs-inner');

      this.MAX_ZOOM = 3.0;        // Max via mouse wheel (desktop)
      this.MIN_ZOOM = 0.7;
      this.ZOOM_SPEED = 0.0015;   // Smooth scroll zoom

      this.initMediaItems();
      this.renderThumbnails();
      this.bindGlobalEvents();
      this.blockNativeZoom();
    }

initMediaItems() {
  const seen = new Set();
  
  // HANDLE IMAGES (but skip video containers)
  document.querySelectorAll('.product-media-container--image, .product-media-container.media-fit-cover, .product-media-container.media-fit-contain').forEach(container => {
    // SKIP if this container has a video
    if (container.classList.contains('product-media-container--video') || 
        container.querySelector('video') || 
        container.hasAttribute('data-media-type') && container.getAttribute('data-media-type') === 'video') {
      return;
    }
    
    const img = container.querySelector('img');
    if (!img || !img.src || seen.has(img)) return;
    seen.add(img);

    const lowRes = img.currentSrc || img.src;
    const hiRes = lowRes.replace(/([._]\d+x\d+)(\.[a-zA-Z]{3,4})/, '_2048x$2');
    const thumb = lowRes.replace(/([._]\d+x\d+)(\.[a-zA-Z]{3,4})/, '_600x$2');

    this.items.push({ 
      lowRes, 
      hiRes, 
      thumb, 
      alt: img.alt || '', 
      element: img, 
      container,
      isVideo: false 
    });

    container.style.cursor = 'zoom-in';
    container.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const idx = this.items.findIndex(i => i.element === img);
      if (idx >= 0) this.open(idx);
    });
  });

  // HANDLE VIDEOS
  document.querySelectorAll('.product-media-container--video, .product-media-container[data-media-type="video"]').forEach(container => {
    const video = container.querySelector('video');
    if (!video || seen.has(video)) return;
    seen.add(video);

    const videoSrc = video.querySelector('source')?.src || video.src;
    const poster = video.poster || '';
    const thumb = poster || videoSrc;

    this.items.push({ 
      lowRes: poster, 
      hiRes: videoSrc,
      videoSrc: videoSrc,
      thumb: thumb, 
      alt: 'Product Video', 
      element: video, 
      container,
      isVideo: true 
    });

    container.style.cursor = 'zoom-in';
    container.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const idx = this.items.findIndex(i => i.element === video);
      if (idx >= 0) this.open(idx);
    });
  });
}


    blockNativeZoom() {
      document.addEventListener('click', e => {
        if (e.target.closest('[on\\:click*="zoom"], zoom-dialog')) {
          e.stopPropagation();
          e.preventDefault();
        }
      }, true);
    }

    bindGlobalEvents() {
      this.root.querySelector('.pswp__button--close')?.addEventListener('click', () => this.close());
      document.getElementById('prevMediaBtn')?.addEventListener('click', () => this.navigate(-1));
      document.getElementById('nextMediaBtn')?.addEventListener('click', () => this.navigate(1));
      this.root.querySelector('.pswp__bg')?.addEventListener('click', () => this.close());

      document.addEventListener('keydown', e => {
        if (this.root.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.navigate(-1);
        if (e.key === 'ArrowRight') this.navigate(1);
      });
    }

    open(index) {
      this.current = index;
      this.isZoomed = false;
      this.scale = 0.8;
      this.translate = { x: 0, y: 0 };

      this.root.style.display = 'block';
      this.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-body-scroll-lock');
      this.show(this.current);
    }

    close() {
      this.container.innerHTML = '';
      this.root.style.display = 'none';
      this.root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-body-scroll-lock');
    }

    navigate(delta) {
      this.current = (this.current + delta + this.items.length) % this.items.length;
      this.show(this.current);
    }

    show(index) {
  const item = this.items[index];
  this.container.innerHTML = '';

  const wrapper = document.createElement('div');
  wrapper.className = 'custom-lightbox__image-wrap';

  // CHECK IF IT'S A VIDEO
  if (item.isVideo) {
    const video = document.createElement('video');
    video.src = item.videoSrc || item.hiRes;
    video.controls = true;
    video.autoplay = true;
    video.muted = true;  // Required for autoplay
    video.playsinline = true;  // Required for mobile
    video.loop = true;  // Optional: loop the video
    video.style.cssText = 'width:100%;height:100%;object-fit:contain;';
    
    // Ensure autoplay triggers
    video.addEventListener('loadeddata', () => {
      video.play().catch(err => console.log('Autoplay prevented:', err));
    });

    wrapper.appendChild(video);
    this.container.appendChild(wrapper);
    this.updateCounter(index);
    this.highlightThumbnail(index);
    return;
  }

  // EXISTING IMAGE CODE (keep as-is)
  const placeholder = new Image();
  placeholder.src = item.lowRes;
  placeholder.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;filter:blur(16px);opacity:0.7;transform:scale(0.9);transition:opacity 0.8s;';
  wrapper.appendChild(placeholder);

  const img = new Image();
  img.src = item.hiRes;
  img.alt = item.alt;
  img.draggable = false;
  img.style.cssText = 'max-width:none;max-height:none;will-change:transform;opacity:0;transition:all 0.8s cubic-bezier(0.22,1,0.36,1);';

  img.onload = () => {
    wrapper.appendChild(img);
    placeholder.style.opacity = '0';
    img.style.opacity = '1';

    this.applyTransform(img);
    this.updateCounter(index);
    this.highlightThumbnail(index);

    wrapper.addEventListener('click', (e) => {
      if (e.target !== img && e.target !== wrapper) return;
      this.isZoomed = !this.isZoomed;
      this.scale = this.isZoomed ? 1.0 : 0.8;
      this.translate = { x: 0, y: 0 };
      this.applyTransform(img);
      wrapper.style.cursor = this.isZoomed ? 'zoom-out' : 'zoom-in';
    });

    if (window.innerWidth >= 750) {
      this.enableGodTierDesktopZoom(img, wrapper);
    }

    this.bindMobileGestures(img, wrapper);
  };

  this.container.appendChild(wrapper);
}


    applyTransform(img) {
      img.style.transform = `translate(${this.translate.x}px, ${this.translate.y}px) scale(${this.scale})`;
    }

    // GOD-TIER DESKTOP ZOOM: Hover + Mouse Wheel
    enableGodTierDesktopZoom(img, wrapper) {
      wrapper.style.cursor = this.isZoomed ? 'zoom-out' : 'zoom-in';

      // Hover-follow origin
      wrapper.addEventListener('mousemove', (e) => {
        if (!this.isZoomed) return;
        const rect = wrapper.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = `${x}% ${y}%`;
      });

      // Mouse wheel zoom (smooth like Figma)
      wrapper.addEventListener('wheel', (e) => {
        if (!this.isZoomed) return;
        e.preventDefault();

        const delta = e.deltaY > 0 ? -1 : 1;
        const zoomFactor = 1 + delta * this.ZOOM_SPEED * 100;

        this.scale = Math.max(this.MIN_ZOOM, Math.min(this.MAX_ZOOM, this.scale * zoomFactor));
        this.applyTransform(img);
      }, { passive: false });

      // Hover zoom effect when zoomed in
      wrapper.addEventListener('mouseenter', () => {
        if (this.isZoomed && this.scale <= 1.1) {
          img.style.transition = 'transform 0.9s cubic-bezier(0.22,1,0.36,1)';
          img.style.transform = `translate(${this.translate.x}px, ${this.translate.y}px) scale(1.4)`;
        }
      });

      wrapper.addEventListener('mouseleave', () => {
        if (this.isZoomed && this.scale <= 1.1) {
          img.style.transition = 'transform 0.7s cubic-bezier(0.22,1,0.36,1)';
          img.style.transform = `translate(${this.translate.x}px, ${this.translate.y}px) scale(${this.scale})`;
        }
      });
    }

    bindMobileGestures(img, wrapper) {
      let startDist = 0;
      let startScale = this.scale;

      const apply = () => this.applyTransform(img);
      const constrain = () => {
        const rect = img.getBoundingClientRect();
        const maxX = Math.max(0, (rect.width - wrapper.offsetWidth) / 2);
        const maxY = Math.max(0, (rect.height - wrapper.offsetHeight) / 2);
        this.translate.x = Math.max(-maxX, Math.min(maxX, this.translate.x));
        this.translate.y = Math.max(-maxY, Math.min(maxY, this.translate.y));
        apply();
      };

      let dragging = false;
      wrapper.addEventListener('pointerdown', e => {
        if (this.scale <= 0.9) return;
        dragging = true;
        wrapper.setPointerCapture(e.pointerId);
        wrapper.classList.add('dragging');
        this.startX = e.clientX - this.translate.x;
        this.startY = e.clientY - this.translate.y;
      });
      wrapper.addEventListener('pointermove', e => {
        if (!dragging) return;
        this.translate.x = e.clientX - this.startX;
        this.translate.y = e.clientY - this.startY;
        apply();
      });
      wrapper.addEventListener('pointerup', () => {
        if (dragging) {
          dragging = false;
          wrapper.classList.remove('dragging');
          constrain();
        }
      });

      wrapper.addEventListener('touchstart', e => {
        if (e.touches.length === 2) {
          startDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          startScale = this.scale;
        }
      }, { passive: true });

      wrapper.addEventListener('touchmove', e => {
        if (e.touches.length === 2) {
          e.preventDefault();
          const dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
          this.scale = Math.max(0.8, Math.min(1.5, startScale * (dist / startDist)));
          apply();
        }
      }, { passive: false });
    }

    updateCounter(i) { if (this.counter) this.counter.textContent = `${i + 1} / ${this.items.length}`; }
    highlightThumbnail(i) {
      this.thumbsInner?.querySelectorAll('.pswp__thumb').forEach((t, idx) => t.classList.toggle('active', idx === i));
    }
    renderThumbnails() {
      if (!this.thumbsInner) return;
      this.thumbsInner.innerHTML = this.items.map((it, i) => `
        <img src="${it.thumb}" class="pswp__thumb ${i===0?'active':''}" data-index="${i}" loading="lazy">
      `).join('');
      this.thumbsInner.addEventListener('click', e => {
        const t = e.target.closest('.pswp__thumb');
        if (t) this.show(parseInt(t.dataset.index));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new GodTierLuxuryLightbox());
  } else {
    new GodTierLuxuryLightbox();
  }
})();